import { render, staticRenderFns } from "./SseDisplayTable.vue?vue&type=template&id=50afe604"
import script from "./SseDisplayTable.vue?vue&type=script&lang=js"
export * from "./SseDisplayTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports